// extracted by mini-css-extract-plugin
export default {"spacingRadioGroup":"InformCNPJCPF_spacingRadioGroup__PVosn","spacingIagree":"InformCNPJCPF_spacingIagree__heKT4"};